import { resolve, noop } from './util';
import bn from 'bignumber.js';

const cThresholdForApproved = bn(2).pow(255);

export default ({ erc20Contract, faucetContract, optionality, account, serviceFactory, log, cache, config }) => cache((tokenAddress, authorizationAddress) => {

  if (!tokenAddress) {
    return serviceFactory({
      name: 'empty-token-service',
      initial: {
        balance: 0
      },
      subscribe: (update) => { update({}) }
    })
  }
  var subscribedAccount;
  var watchers = [];

  return serviceFactory({
    name: 'token-service',
    initial: {
      approved: false,
      setAuthorization: async (authorized) => {
        var authAddr = authorizationAddress || (await optionality.deployed()).address;
        var erc20 = await erc20Contract.at(tokenAddress);
        return erc20.approve(authAddr, authorized ? bn(2).pow(256).minus(1).toString() : 0)
      },
      transfer: async (to, amount) => {
        var erc20 = await erc20Contract.at(tokenAddress);
        var decimals = await erc20.decimals();
        return erc20.transfer(to, bn(+amount).times(bn(10).pow(+decimals)).toString());
      }
    },
    subscribe: (update) => {

      const refreshing = [true, true, true];
      const updateRefresh = (value, i, _refreshing = false) => {
        refreshing[i] = _refreshing
        update(value, refreshing.includes(true))
      }

      log.handle("updating token-service general info", async () => {

        const token = await erc20Contract.at(tokenAddress);
        const value = await resolve(token, ['symbol', 'name', 'decimals', 'address'], 'contract')
        value.faucet = false;
        if (config && config.tokenService && config.tokenService.faucets[value.symbol]) {
          value.faucet = true;
          value.mint = async (quantity) => {
            const acct = await account.get();
            const faucet = await faucetContract.at(tokenAddress);
            const decimals = await faucet.decimals();
            return faucet.mint(bn(quantity).times(bn(10).pow(+decimals)).toString(), { from: acct.account })
          }
        }
        updateRefresh(value, 0);
      })

      const rewatch = (fn) => {
        if (watchers.length > 0) unwatch();
        fn().forEach(w => watchers.push(w));
      }
      const unwatch = () => {
        watchers.forEach(w => w.stopWatching(noop));
        watchers.length = 0;
      }
      const accountUnsub = account.subscribe(async (acct) => {
        if (acct._refreshing) {
          update({}, true);
        } else if (acct.account !== subscribedAccount) {
          subscribedAccount = acct.account;
          refreshing[2] = true;
          updateRefresh({}, 1, true);
          const erc20 = await erc20Contract.at(tokenAddress);
          const decimals = await erc20.decimals();
          const authAddr = authorizationAddress || (await optionality.deployed()).address;

          const factor = bn(10).pow(+decimals);
          const refreshBalance = () => log.handle('token-service:update-balance', () => erc20.balanceOf(acct.account).then(value => {
            updateRefresh({ balance: bn(value).div(factor) }, 1)
          }));
          const refreshAllowance = () => log.handle('token-service:update-allowance', () => erc20.allowance(acct.account, authAddr).then(value => {
            updateRefresh({
              allowance: bn(value).div(factor),
              approved: bn(value).gt(cThresholdForApproved)
            }, 2)
          }));

          rewatch(() => [
            erc20.Transfer({ from: subscribedAccount }).watch(refreshBalance),
            erc20.Transfer({ to: subscribedAccount }).watch(refreshBalance),
            erc20.Approval({ owner: subscribedAccount, spender: authAddr }).watch(refreshAllowance)
          ]);

          await Promise.all([refreshBalance(), refreshAllowance()])
        }
      })
      return () => {
        accountUnsub();
        subscribedAccount = null;
        unwatch();
      }
    }
  })
})



// WEBPACK FOOTER //
// ./src/api/token-service.js